<template>
  <div class="toggle-filters">
    <button class="btn-toggle" :class="{'active': chosen === 'daily'}" @click.prevent="change('daily')">Daily</button>
    <button class="btn-toggle" :class="{'active': chosen === 'monthly'}" @click.prevent="change('monthly')">Monthly</button>
    <button class="btn-toggle" :class="{'active': chosen === 'yearly'}" @click.prevent="change('yearly')">Yearly</button>
  </div>
</template>

<script>
export default {
  name: 'toggle-filters',
  data() {
    return {
      chosen: 'daily'
    }
  },
  methods: {
    change(payload) {
      this.chosen = payload
      this.$emit('filterChanged', payload)
    }
  }
}
</script>
